var SpinnerDataTestIdEnum = /* @__PURE__ */ ((SpinnerDataTestIdEnum2) => {
  SpinnerDataTestIdEnum2["SPINNER"] = "spinner";
  return SpinnerDataTestIdEnum2;
})(SpinnerDataTestIdEnum || {});
export {
  SpinnerDataTestIdEnum
};
